module.exports = "<li class=\"<%= menu__item %>\">\r\n    <i class=\"<%= menu__itemIcon %> gw-icon fa fa-{{layoutController.icon()}}\"></i>\r\n    <div gw-partial-target></div>\r\n</li>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/Menu/menu-item.html
// module id = 579
// module chunks = 0